import { REACT_APP_BASE_URL, REACT_APP_API_PREFIX, UTILIZATION_METRICS_BASE_URL } from '../../../config';

export const Endpoints = {
  METRICS_SINGLE: `${REACT_APP_BASE_URL}/${REACT_APP_API_PREFIX}/metrics`,
  METRICS_LIST: `${REACT_APP_BASE_URL}/${REACT_APP_API_PREFIX}/metrics/list`,
  PRECACHE_SESSIONS: `${REACT_APP_BASE_URL}/${REACT_APP_API_PREFIX}/metrics/precacheSessions`,
  AUTH_VERIFY: `${REACT_APP_BASE_URL}/${REACT_APP_API_PREFIX}/authentication/verify`,
  LOCATIONS: `${REACT_APP_BASE_URL}/${REACT_APP_API_PREFIX}/locations`,
  UTILIZATION_METRICS: `${UTILIZATION_METRICS_BASE_URL}/api/v1/locations/metrics`,
} as const;
export type EndpointsType = typeof Endpoints[keyof typeof Endpoints];
